import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FaSignOutAlt, FaTimes, FaExclamationTriangle } from "react-icons/fa";

import styles from "./UserMenu.module.css";

const UserLogoutConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div className={styles.userInfoModalOverlay} onMouseDown={onClose}>
      <div
        className={`${styles.userInfoModalBox} ${styles.logoutConfirmModalBox}`}
        onMouseDown={(e) => e.stopPropagation()}
        dir="rtl"
      >
        <div className={styles.userInfoModalHeader}>
          <div className={styles.userInfoModalTitleBox}>
            <FaExclamationTriangle className={styles.logoutConfirmIcon} />

            <div>
              <div className={styles.userInfoModalTitle}>
                خروج از حساب کاربری
              </div>

              <div className={styles.userInfoModalSubTitle}>
                برای خروج از حساب، تایید شما لازم است
              </div>
            </div>
          </div>

          <button
            type="button"
            className={styles.userInfoModalClose}
            onClick={onClose}
            title="بستن"
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <div className={styles.userInfoModalBody}>
          <div className={styles.logoutConfirmBody}>
            <div className={styles.logoutConfirmBigIcon}>
              <FaSignOutAlt />
            </div>

            <div className={styles.logoutConfirmQuestion}>
              آیا از خروج از حساب کاربری اطمینان دارید؟
            </div>
          </div>
        </div>

        <div
          className={`${styles.userInfoModalFooter} ${styles.logoutConfirmFooter}`}
        >
          <button
            type="button"
            className={styles.userInfoSecondaryBtn}
            onClick={onClose}
            disabled={isLoading}
            title="انصراف"
          >
            <FaTimes />
            انصراف
          </button>

          <button
            type="button"
            className={styles.logoutConfirmBtn}
            onClick={onConfirm}
            disabled={isLoading}
            title="خروج"
          >
            <FaSignOutAlt />
            {isLoading ? "در حال خروج..." : "خروج"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default UserLogoutConfirmModal;
